import store from '@/store'
import router from '@/router'
import { mutationTypes, actionTypes } from '@/store/modules/SessionTypes'
import HTTP from '@/common/HTTP'

class SessionService {

  constructor(store) {
    this.store = store
    this.session = this.loadSession()
      .catch(() => {
      // session verification failed - log user out
        this.logout()
        router.push({
          path: '/login',
          query: { redirect: router.app.$route.fullPath }
        })
      })
  }

  getSession() {
    return this.session;
  }

  login(loginInformation) {
    return this.store.dispatch(actionTypes.CODE, loginInformation)
      .then((state) => {
        SessionService.persistSession({ accessToken: state.session.accessToken, expiresIn: state.session.expiresIn })
        this.applyDefaultAuthorizationHeader()
      })
      .then(() => this.store.dispatch(actionTypes.FETCH_AUTHORITIES))
     // .then(() => this.store.dispatch(actionTypes.FETCH_ANALYSIS_TYPES))
  }

  code(code, accessToken, expiresIn) {
    return this.store.dispatch(actionTypes.VERIFY_CODE, code, accessToken, expiresIn)
     .then(() => this.store.dispatch(actionTypes.FETCH_AUTHORITIES))
     .then(() => this.store.dispatch(actionTypes.FETCH_ANALYSIS_TYPES))
  }

  static persistSession(session) {
    localStorage.setItem('bm-session', JSON.stringify(session))
  }

  static destroySession() {
    localStorage.removeItem('bm-session')
  }

  loadSession() {
    const sessionJSON = localStorage.getItem('bm-session')
    if (sessionJSON) {
      const session = JSON.parse(sessionJSON)
      this.store.commit(mutationTypes.LOGIN,
        { accessToken: session.accessToken, expiresIn: session.expiresIn, user: {} })
      this.applyDefaultAuthorizationHeader()

      return HTTP.get('users/me').then(({ data }) => {
        if (data.email) {
          this.store.commit(mutationTypes.LOGIN,
            { accessToken: session.accessToken, expiresIn: session.expiresIn, user: data })

          return data
        }
        throw new Error('stored session expired')
      }).then(() => this.store.dispatch(actionTypes.FETCH_AUTHORITIES))
        .then(() => this.store.dispatch(actionTypes.FETCH_ANALYSIS_TYPES))
    }

    return Promise.resolve('no session found')
  }

  applyDefaultAuthorizationHeader() {
    HTTP.defaults.headers.common.Authorization = `Bearer ${this.store.state.Session.session.accessToken}`
  }

  logout() {
    this.store.commit(mutationTypes.LOGOUT)
    delete HTTP.defaults.headers.common.Authorization
    SessionService.destroySession()
  }
}

export const Session = new SessionService(store)



// WEBPACK FOOTER //
// ./src/common/Session.js